<template>
  <div class="data-view" v-cloak>
    <div class="data-view-header">
      <div class="view-title">
        <!-- <i class="iconfont-erp iconshujugailan"></i> -->
        今日交易情况
      </div>
    </div>
    <el-row :gutter="5">
      <el-col :xs="6" :sm="6" :md="6">
        <div class="trade-clr" id="tradeDount"></div>
        <!-- <div class="trade-clr" id="trade-clr"></div> -->
      </el-col>
      <el-col :xs="6" :sm="6" :md="6">
        <!-- <div id="order-clr" class="order-clr"></div> -->
        <div class="order-clr" id="orderDount"></div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12">
        <div class="data-view-content">
          <div class="data-view-item">
            <div class="data-view-item-title">近30天买家数</div>
            <div class="data-view-item-content">线上：{{ res.MonthBuyers.OnLine }}</div>
            <!-- <div class="data-view-item-content">线下：{{ res.MonthBuyers.OffLine }}</div> -->
          </div>
          <div class="data-view-item">
            <div class="data-view-item-title">近30天订单数</div>
            <div class="data-view-item-content">线上：{{ res.MonthCount.OnLine }}</div>
            <!-- <div class="data-view-item-content">线下：{{ res.MonthCount.OffLine }}</div> -->
          </div>
          <div class="data-view-item">
            <div class="data-view-item-title">近30天客单价</div>
            <div class="data-view-item-content">线上：{{ res.MonthUnitPrice.OnLine }}</div>
            <!-- <div class="data-view-item-content">线下：{{ res.MonthUnitPrice.OffLine }}</div> -->
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- <ul class="view-list">
      <li class="sale-item">
        <div class="item-title"><i class="iconfont-erp iconshouyin mr4"></i>今日销售额</div>
        <div class="today-num"><span>￥</span>{{ res.SalesVolume }}</div>
      </li>
      <li class="order-item">
        <div class="item-title"><i class="iconfont-erp icondingdanchaxun mr4"></i>今日订单数</div>
        <div class="today-num">{{ res.Count }}</div>
      </li>
      <li>
        <div class="item-title"><i class="iconfont-erp iconqiankuan mr4"></i>累积欠款</div>
        <div class="today-num"><span>￥</span>{{ res.AccumulatedArrears }}</div>
      </li>
    </ul>
    <ul class="view-list">
      <li class="sale-item">
        <div class="item-title"><i class="iconfont-erp iconshouyin mr4"></i>昨日销售额</div>
        <div class="prev-num"><span>￥</span>{{ res.YesterdaySalesVolume }}</div>
      </li>
      <li class="order-item">
        <div class="item-title"><i class="iconfont-erp icondingdanchaxun mr4"></i>昨日订单数</div>
        <div class="prev-num">{{ res.YesterdayCount }}</div>
      </li>
    </ul> -->
  </div>
</template>

<script>
import echarts from "echarts";
export default {
  data() {
    return {
      res: {
        MonthBuyers: {
          OnLine: 0,
          OffLine: 0,
        },
        MonthCount: {
          OnLine: 0,
          OffLine: 0,
        },
        MonthUnitPrice: {
          OnLine: 0,
          OffLine: 0,
        },
      },
    };
  },
  created() {
    this.getViewData();
  },
  mounted() {},
  methods: {
    getViewData() {
      this.$ajax.post("/api/Order/GetSalesVolumeV2", {}).then((res) => {
        // console.log(res);
        this.res = res;

        const dataMoney = [
          { value: res.ErpSalesVolume, name: "ERP订单" },
          { value: res.AliSalesVolume, name: "1688订单" },
        ];

        const dataOrder = [
          { value: res.ErpCount, name: "ERP订单" },
          { value: res.AliCount, name: "1688订单" },
        ];
        // console.log(res.Count == 0);
        // console.log(dataMoney);
        // console.log(dataOrder);
        this.eChartDonutRender("tradeDount", "销售额", res.SalesVolume, dataMoney);
        this.eChartDonutRender("orderDount", "订单数", res.Count, dataOrder);
      });
    },
    eChartDonutRender(id, centerTitle, count, data) {
      var myChart = echarts.init(document.getElementById(id));
      var option = {
        graphic: [
          {
            //环形图中间添加文字
            type: "text", //通过不同top值可以设置上下显示
            left: "center",
            top: "43%",
            style: {
              text: centerTitle + "\n" + count,
              textAlign: "center",
              width: 30,
              height: 30,
              fontSize: 13,
            },

            textStyle: {
              color: "#999",
            },
          },
        ],
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        legend: {
          orient: "horizontal",
          bottom: 0,
          itemWidth: 5,
          itemHeight: 5,
          data: ["ERP订单", "1688订单"],
        },
        series: [
          {
            name: centerTitle,
            type: "pie",
            radius: ["45%", "60%"],
            color: ["#ff5500", "#11997E"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
              },
            },
            labelLine: {
              show: false,
            },
            data: data,
          },
        ],
      };
      myChart.setOption(option);
    },
  },
};
</script>

<style lang="scss" scoped>
// insertCss(`
.ring-guide-name {
  color: white;
}

// #order-clr {
//   .g2plot-htmlStatistic {
//     .ring-guide-html {
//       .ring-guide-name {
//         color: white !important;
//       }
//       .ring-guide-value {
//         color: white !important;
//         opacity: 0.7;
//         font-size: 14px !important;
//       }
//     }
//   }
// }
.data-view {
  background: #fff;
  padding: 20px 30px;
  padding-bottom: 40px;
  margin-bottom: 20px;
}
.data-view-header {
  width: 100%;
  // padding: 15px 0;
  // height: 50px;
}

.view-title {
  font-size: 16px;
  color: #333;
  font-weight: bold;

  i {
    padding-right: 5px;
    font-weight: normal;
    font-size: 18px;
    color: #333;
  }
}
.trade-clr {
  width: 100%;
  height: 150px;
  //   background-color: red;
}
.order-clr {
  width: 100%;
  height: 150px;
  //   background-color: yellow;
}
.data-view-content {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 130px;
  .data-view-item {
    border: 1px solid rgba(153, 153, 153, 0.836);
    border-radius: 8px;
    // width: 110px;
    height: 110px;
    box-sizing: border-box;
    padding: 0 15px;
    .data-view-item-title {
      font-weight: bold;
      height: 40px;
      text-align: center;
      width: 100%;
      line-height: 40px;
      text-align: center;
    }
    .data-view-item-content {
      padding: 5px 0;
    }
  }
}
.view-list {
  overflow: hidden;
  padding-top: 10px;

  i {
    color: #ff5000;
  }

  li {
    float: left;
  }

  .sale-item {
    width: 280px;
  }

  .order-item {
    width: 200px;
  }

  .item-title {
    font-size: 12px;
    color: #666;
    padding-bottom: 5px;
  }

  .today-num {
    font-size: 30px;
    color: #ff5000;
    font-weight: bold;

    span {
      font-size: 14px;
    }
  }

  .prev-num {
    font-weight: bold;
    font-size: 18px;
    color: #333;
  }
}
.mr4 {
  margin-right: 4px;
}
</style>
